import {
  DespesasToRelease,
  MensagemValidacao,
  StatusValidacaoDespesaT,
} from "@fl/shared/src/types/models/superlogica/despesas";

const despesaValidation = (
  lancamento: DespesasToRelease
): DespesasToRelease => {
  const mensagens: MensagemValidacao[] = [
    ...fornecedor(lancamento),
    ...apropriacoes(lancamento),
    ...retencoes(lancamento),
  ];

  const temErro = mensagens.some((msg) => msg.status === "ERRO");
  const temAlerta = mensagens.some((msg) => msg.status === "ALERTA");

  let status: StatusValidacaoDespesaT = "SUCESSO";
  if (temErro) {
    status = "ERRO";
  } else if (temAlerta) {
    status = "ALERTA";
  }

  lancamento.validacao = {
    status,
    mensagens,
  };

  return lancamento;
};

const fornecedor = (lancamento: DespesasToRelease): MensagemValidacao[] => {
  const mensagens: MensagemValidacao[] = [];

  if (!lancamento.fornecedor) {
    mensagens.push({
      id: "prestador",
      message: "Fornecedor não cadastrado",
      status: "ERRO",
      title: "Fornecedor",
    });
  }

  return mensagens;
};

const apropriacoes = (lancamento: DespesasToRelease): MensagemValidacao[] => {
  const mensagens: MensagemValidacao[] = [];

  // Exemplo: validar se há apropriações
  if (!lancamento.apropriacoes || lancamento.apropriacoes.length === 0) {
    mensagens.push({
      id: "apropriacoes",
      message: "Sem apropriações definidas para a despesa",
      status: "ALERTA",
      title: "Apropriações",
    });
  }

  return mensagens;
};

const retencoes = (lancamento: DespesasToRelease): MensagemValidacao[] => {
  const mensagens: MensagemValidacao[] = [];

  // Exemplo: validar valores de retenção
  if (
    lancamento.retencoes?.some(
      (r) => r.vl_rv2_valorretido_des && r.vl_rv2_valorretido_des > 10000
    )
  ) {
    mensagens.push({
      id: "retencao-alta",
      message: "Valor de retenção acima do esperado",
      status: "ALERTA",
      title: "Retenções",
    });
  }

  return mensagens;
};

/*
const checkRetencoesResumed = (
  lancamento: LancamentoAttributes,
  newErrors: ResumedLancsErrors[],
  pisID: number,
  inssID: number,
  issID: number,
  irID: number
) => {
  if (lancamento.NFe) {
    //PIS
    if (lancamento.NFe.pis_pasep > 0) {
      if (
        !lancamento.LancamentoRetencaos ||
        lancamento.LancamentoRetencaos.length === 0
      ) {
        newErrors.push({
          key: uuidv4().toString(),
          message:
            "Retenção de PIS/COFINS/CSLL ausente, porém há informação de retenção na NF.",
          type: "warning",
          priority: 1,
        });
      } else {
        const pisRetencao = lancamento.LancamentoRetencaos.find(
          (item) => item.id_rv2_imposto_des === pisID
        );
        if (!pisRetencao) {
          newErrors.push({
            key: uuidv4().toString(),
            message:
              "Retenção de PIS/COFINS/CSLL ausente, porém há informação de retenção na NF.",
            type: "warning",
            priority: 1,
          });
        } else {
          if (!lancamento.id_natrend_des) {
            newErrors.push({
              key: uuidv4().toString(),
              message: "Natureza de rendimento não informada.",
              type: "danger",
              priority: 2,
            });
          }
        }
      }
    } else {
      if (lancamento.LancamentoRetencaos !== null) {
        if (lancamento.LancamentoRetencaos !== undefined) {
          if (lancamento.LancamentoRetencaos.length > 0) {
            const pisRetencao = lancamento.LancamentoRetencaos.find(
              (item) => item.id_rv2_imposto_des === pisID
            );
            if (pisRetencao) {
              if (!lancamento.id_natrend_des) {
                newErrors.push({
                  key: uuidv4().toString(),
                  message: "Natureza de rendimento não informada.",
                  type: "danger",
                  priority: 2,
                });
              }
            }
          }
        }
      }
    }

    //INSS
    if (lancamento.NFe.inss > 0) {
      if (
        !lancamento.LancamentoRetencaos ||
        lancamento.LancamentoRetencaos.length === 0
      ) {
        newErrors.push({
          key: uuidv4().toString(),
          message:
            "Retenção de INSS ausente, porém há informação de retenção na NF.",
          type: "warning",
          priority: 1,
        });
      } else {
        const inssRetencao = lancamento.LancamentoRetencaos.find(
          (item) => item.id_rv2_imposto_des === inssID
        );

        if (!inssRetencao) {
          newErrors.push({
            key: uuidv4().toString(),
            message:
              "Retenção de INSS ausente, porém há informação de retenção na NF.",
            type: "warning",
            priority: 1,
          });
        } else {
          if (!lancamento.id_classificacaotributaria_des) {
            newErrors.push({
              key: uuidv4().toString(),
              message: "Classificação Tributária não informada.",
              type: "danger",
              priority: 2,
            });
          }

          if (!lancamento.id_classservicoprestado_des) {
            newErrors.push({
              key: uuidv4().toString(),
              message: "Classificação do Serviço Prestado não informado.",
              type: "danger",
              priority: 2,
            });
          }
        }
      }

      newErrors.push({
        key: uuidv4().toString(),
        message:
          "Lançamento possui INSS, por favor confirir para certificar que não há abatimentos.",
        type: "warning",
        priority: 1,
      });
    } else {
      if (lancamento.LancamentoRetencaos !== null) {
        if (lancamento.LancamentoRetencaos !== undefined) {
          if (lancamento.LancamentoRetencaos.length > 0) {
            const inssRetencao = lancamento.LancamentoRetencaos.find(
              (item) => item.id_rv2_imposto_des === inssID
            );
            if (inssRetencao) {
              console.log(
                "lancamento.id_classificacaotributaria_des",
                lancamento.id_classificacaotributaria_des
              );
              if (!lancamento.id_classificacaotributaria_des) {
                newErrors.push({
                  key: uuidv4().toString(),
                  message: "Classificação Tributária não informada.",
                  type: "danger",
                  priority: 2,
                });
              }

              if (!lancamento.id_classservicoprestado_des) {
                newErrors.push({
                  key: uuidv4().toString(),
                  message: "Classificação do Serviço Prestado não informado.",
                  type: "danger",
                  priority: 2,
                });
              }
            }
          }
        }
      }
    }

    //ISS
    if (lancamento.NFe.iss_retido === true) {
      if (
        !lancamento.LancamentoRetencaos ||
        lancamento.LancamentoRetencaos.length === 0
      ) {
        newErrors.push({
          key: uuidv4().toString(),
          message:
            "Retenção de ISS ausente, porém há informação de retenção na NF.",
          type: "warning",
          priority: 1,
        });
      } else {
        const issRetencao = lancamento.LancamentoRetencaos.find(
          (item) => item.id_rv2_imposto_des === issID
        );

        if (!issRetencao) {
          newErrors.push({
            key: uuidv4().toString(),
            message:
              "Retenção de ISS ausente, porém há informação de retenção na NF.",
            type: "warning",
            priority: 1,
          });
        }
      }
    }

    //IR
    if (lancamento.NFe.ir > 0) {
      if (
        !lancamento.LancamentoRetencaos ||
        lancamento.LancamentoRetencaos.length === 0
      ) {
        newErrors.push({
          key: uuidv4().toString(),
          message:
            "Retenção de IR ausente, porém há informação de retenção na NF.",
          type: "warning",
          priority: 1,
        });
      } else {
        const irRetencao = lancamento.LancamentoRetencaos.find(
          (item) => item.id_rv2_imposto_des === irID
        );

        if (!irRetencao) {
          newErrors.push({
            key: uuidv4().toString(),
            message:
              "Retenção de IR ausente, porém há informação de retenção na NF.",
            type: "warning",
            priority: 1,
          });
        }
      }
    }
  }

  return newErrors;
};
*/

export default despesaValidation;
